export default __webpack_public_path__ + "static/media/293.37d10927.png";